import axios from 'axios'

// 庫存計算：products.stock 以「片/瓶」計，每個規格的 quantity = 該規格扣幾片/瓶
// （例：面膜 1盒=5、3盒送1盒=20、5盒送2盒=35）

// 購物車裡同一商品已佔用的件數
export function unitsInCart(cartItems, product) {
  if (!product || !Array.isArray(cartItems)) return 0
  const variants = product.Variants || []
  return cartItems
    .filter(i => Number(i.product_id) === Number(product.product_id) && !i.is_gift)
    .reduce((sum, i) => {
      const v = variants.find(x => Number(x.variant_id) === Number(i.variant_id))
      return sum + (v ? Number(v.quantity || 0) * Number(i.quantity || 0) : 0)
    }, 0)
}

// 扣掉購物車已佔用後，還能再買的件數
export function availableUnits(cartItems, product) {
  if (!product || product.stock == null) return Infinity
  return Math.max(0, Number(product.stock) - unitsInCart(cartItems, product))
}

// 這個規格最多還能再加幾組
export function maxQtyForVariant(cartItems, product, variant) {
  const per = Number(variant && variant.quantity) || 0
  if (per <= 0) return 99
  const avail = availableUnits(cartItems, product)
  if (avail === Infinity) return 99
  return Math.min(99, Math.floor(avail / per))
}

export function stockShortMessage(cartItems, product) {
  const left = availableUnits(cartItems, product)
  const unit = (product && product.unit) || ''
  const inCart = unitsInCart(cartItems, product)
  return inCart > 0
    ? `庫存不足（目前剩 ${product.stock} ${unit}，購物車已有 ${inCart} ${unit}），請減少數量或改選其他規格`
    : `庫存不足（目前剩 ${left} ${unit}），請減少數量或改選其他規格`
}

// 向伺服器確認最新庫存（畫面上的庫存可能是很久以前載入的舊資料）
// 回傳 { ok, message }；連線失敗時不擋（送出訂單時伺服器仍會再檢查）
export async function checkStockRemote(cartItems) {
  try {
    const items = (cartItems || [])
      .filter(i => !i.is_gift)
      .map(i => ({
        product_id: i.product_id,
        variant_id: i.variant_id,
        variant_name: i.variant_name,
        quantity: Number(i.quantity)
      }))
    if (!items.length) return { ok: true, message: '' }
    const res = await axios.post('/api/order/checkStock', { cartItems: items })
    const d = res.data || {}
    return { ok: d.ok !== false, message: d.message || '' }
  } catch (e) {
    return { ok: true, message: '' }
  }
}
